import Vue from 'vue'
import App from './components/app.vue'

// Amplify
import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
Amplify.configure(aws_exports);

// MomentJS
// import moment from 'moment'
// Luxon replacement for momentjs
// import { DateTime } from 'luxon'
import dayjs from 'dayjs'

// Sanitize
import VueSanitize from "vue-sanitize";

// Google Map
import * as GmapVue from 'gmap-vue'
// Geolocation
import VueGeolocation from 'vue-browser-geolocation';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlay, faPause, faMapMarker, faMapPin, faEnvelope, faPhone, faCommentDots, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare, faInstagramSquare, faTwitterSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faPlay, faPause, faMapMarker, faMapPin, faEnvelope, faPhone, faCommentDots, faSpinner)
library.add(faFacebookSquare, faInstagramSquare, faTwitterSquare, faYoutubeSquare)

// Router
import router from './config/router'
// Custom styles
import './scss/styles.scss'

Vue.config.productionTip = false

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyCj0Aac9W0NiGqcnJ_1ULsuOvWp7_zsdKc',
  },
  installComponents: true
})
Vue.component('google-kml-layer', GmapVue.KmlLayer);

Vue.use(VueGeolocation)
Vue.use(VueSanitize)

const sanitizeOptions = {
    allowedTags: [],
    allowedAttributes: {}
}
Vue.use(VueSanitize, sanitizeOptions)

Vue.filter('formatDate', function(value) {
  if (value) {
    // return moment(String(value)).format('MM/DD/YYYY hh:mm A')
    // return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT);
    return dayjs(value).format('MM/DD/YYYY hh:mm A')
  }
});

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + suffix;
  } else {
      return text;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
});
